import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DIALOG_CLASS_NAME = 'Dialog';
export const DIALOG_CLASS_SLOTS = ['root', 'content', 'actions'] as const;

export type DialogClassSlot = (typeof DIALOG_CLASS_SLOTS)[number];

export interface DialogClasses {
	root: string;
	content: string;
	actions: string;

	disableContentPadding: string;
	fullSize: string;
	fullScreenWhenMobile: string;
}

export type DialogClassKey = keyof DialogClasses;

export const getDialogUtilityClass = (slot: string) =>
	generateUtilityClass(DIALOG_CLASS_NAME, slot);

export const dialogClasses = generateUtilityClasses<keyof DialogClasses>(
	DIALOG_CLASS_NAME,
	[
		'root',
		'content',
		'actions',
		'disableContentPadding',
		'fullSize',
		'fullScreenWhenMobile',
	],
);
export default dialogClasses;
